import {useDispatch, useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {markOfferAsSeen} from "../state/seen_offers_slice";

export const useSeenOfferIds = () => {
    const dispatch = useDispatch();
    const seenOfferIds = useSelector((state: IRPStore) => state.seenOffers.ids);

    const addSeenOfferId = (id: number) => {
        dispatch(markOfferAsSeen(id));
    };

    return {seenOfferIds, addSeenOfferId};
};
import {useDispatch, useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {markOfferAsSeen} from "../state/seen_offers_slice";

export const useSeenOfferIds = () => {
    const dispatch = useDispatch();
    const seenOfferIds = useSelector((state: IRPStore) => state.seenOffers.ids);

    const addSeenOfferId = (id: number) => {
        dispatch(markOfferAsSeen(id));
    };

    return {seenOfferIds, addSeenOfferId};
};
